export default {
      id: "sausage-usage",
      viewBox: "0 0 103 103",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#sausage",
      toString: function () {
        return this.url;
      }
    }